import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { NavLink } from "react-router-dom";
import { EditActions } from "../../../actions/editActions";
import { pdApiActions, PdApiActions } from "../../../actions/pdApiActions";
import { Button } from "semantic-ui-react";
import styles from "./IoConfigToString.module.scss";
import arrowLeft from "../../../images/arrow-left-button.svg";

type StateProps = {
  ioConfig: State.IoConfig;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {};

export type IoConfigToStringProps = StateProps & DispatchProps & OwnProps;

const IoConfigToString = (props: IoConfigToStringProps) => (
  // Add submenu specific columns and rows
  <div className="select-configurations-view">
    <div className="io-wrapper">
      <div className="io-header">
        <div className="io-header-title">
          <NavLink to="/tools/io-configuration">
            <img src={arrowLeft} alt="Go back" />
          </NavLink>
          <h2>Open binary config file</h2>
        </div>
        <Button className={styles.actionbutton} as="label" htmlFor="upload" type="button">
          Choose binary IO configuration file
        </Button>
        <input
          type="file"
          id="upload"
          style={{ display: "none" }}
          onChange={e => uploadBinaryIoConfigFile(e, props)}
        />
      </div>
      <div className={["io-content-wrapper", styles.ioBinaryFileContent].join(" ").toString()}>
        <div className={["disabled", styles.field].join(" ").toString()}>
          <textarea
            disabled
            className={styles.ioConfigFileContent}
            value={props.ioConfig.ioConfigFileText}
          />
        </div>
      </div>
    </div>
  </div>
);

const uploadBinaryIoConfigFile = async (
  event: React.ChangeEvent<HTMLInputElement>,
  props: IoConfigToStringProps
): Promise<void> => {
  try {
    // Save the file input valuee into variable and reset the original one,
    // so the onChange event can happen again,
    // if user choose a file with same name as previous one.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const file = event.target.files![0];
    event.target.value = "";
    event.target.files = null;

    // Reading the file might cause exceptions from the browser on a rainy day
    const fileContent: ArrayBuffer = await readFile(file);
    props.pdApiActions.convertBinaryIoConfigToString(fileContent);
  } catch (error) {
    console.error(error);
  }
};

// Takes in the event as argument and returns the file content as array buffer.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/ArrayBuffer
// See: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsArrayBuffer
const readFile = (file: File): Promise<ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    // File read success
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reader.onload = (event: any) => {
      resolve(event.target.result);
    };

    // File read error
    reader.onerror = error => {
      reject(error);
    };

    reader.readAsArrayBuffer(file);
  });

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  mainState: state.main,
  pdApi: state.pdApi,
  ioConfig: state.ioConfig,
  selectedIoConfiguration: state.ioConfig.selectedIoConfiguration
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions | PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(IoConfigToString);
